/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pkl_Nav_LotsInputs */

const vi_pkl_nav_lots = /** @type {(inputs: Pkl_Nav_LotsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Danh sách lô`)
};

/**

* @param {Pkl_Nav_LotsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pkl_nav_lots = /** @type {((inputs?: Pkl_Nav_LotsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pkl_Nav_LotsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pkl_nav_lots(inputs)
});